import { useTranslation } from 'react-i18next';
import { BodyText } from 'vopay';
import { Button, Title, CircleButton } from 'UI';
import styles from './SkippedSubAccountsPanel.module.scss';

type SkippedSubAccountsPanelProps = {
  isOpen: boolean;
  onClose: () => void;
  subAccountNames: string[];
};

export default function SkippedSubAccountsPanel({ isOpen, onClose, subAccountNames }: SkippedSubAccountsPanelProps) {
  const { t } = useTranslation('translations', {
    keyPrefix: 'TransactionApproval.Configuration.Workflows.Update.SubAccountsDialog.skippedPanel',
  });

  const handleCopy = () => {
    navigator.clipboard.writeText(subAccountNames.join('\n'));
  };

  return (
    <div className={`${styles.panel} ${isOpen ? styles.show : ''}`}>
      <header className={styles.header}>
        <div className={styles.titleWrapper}>
          <Title level="5">{t('title', { count: subAccountNames.length, defaultValue: '{{count}} Sub-Account(s)' })}</Title>
          <BodyText size="sm" style={{ color: 'rgba(45, 45, 45, 0.75)' }}>
            {t('description', {
              defaultValue: 'Sub-account(s) that do not have Transaction Approval Workflow enabled:',
            })}
          </BodyText>
        </div>
        <div className={styles.closeButton}>
          <CircleButton icon="close" colorScheme="neutral" size="medium" onClick={onClose} />
        </div>
      </header>

      <div className={styles.content}>
        <ul className={styles.list}>
          {subAccountNames.map((name, i) => (
            <li key={i} className={styles.listItem}>
              {name}
            </li>
          ))}
        </ul>
      </div>

      <footer className={styles.footer}>
        <Button
          colorScheme="secondary"
          size="small"
          iconLeftProps={{ icon: 'content_copy' }}
          onClick={handleCopy}
        >
          {t('copyButton', { defaultValue: 'Copy' })}
        </Button>
      </footer>
    </div>
  );
}
